import React, { useState } from 'react';

interface GroupPickerProps {
  value: string | undefined;
  existingGroups: string[];
  onChange: (g: string | undefined) => void;
}

export const GroupPicker = ({ value, existingGroups, onChange }: GroupPickerProps) => {
  const [mode, setMode] = useState<'select' | 'new'>('select');
  const [newGroup, setNewGroup] = useState('');
  const listId = 'group-datalist';

  const handleSelect = (v: string) => {
    if (v === '__new__') { setMode('new'); return; }
    onChange(v || undefined);
  };

  const handleNewConfirm = () => {
    const g = newGroup.trim();
    onChange(g || undefined);
    setMode('select');
    setNewGroup('');
  };

  if (mode === 'new') {
    return (
      <div className="flex gap-1">
        <input
          autoFocus
          type="text"
          className="flex-1 border border-blue-400 dark:border-blue-500 rounded px-2 py-1.5 text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none"
          placeholder="New group name…"
          value={newGroup}
          onChange={(e) => setNewGroup(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') handleNewConfirm(); if (e.key === 'Escape') { setMode('select'); setNewGroup(''); } }}
        />
        <button type="button" onClick={handleNewConfirm} className="px-2 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600">✓</button>
        <button type="button" onClick={() => { setMode('select'); setNewGroup(''); }} className="px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded hover:bg-gray-50 dark:hover:bg-gray-700">✕</button>
      </div>
    );
  }

  return (
    <>
      <datalist id={listId}>
        {existingGroups.map((g) => <option key={g} value={g} />)}
      </datalist>
      <div className="flex gap-1">
        <select
          className="flex-1 border border-gray-300 dark:border-gray-600 rounded px-2 py-1.5 text-sm bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 focus:outline-none"
          value={value ?? ''}
          onChange={(e) => handleSelect(e.target.value)}
        >
          <option value="">— No group —</option>
          {existingGroups.map((g) => <option key={g} value={g}>{g}</option>)}
          <option value="__new__">+ Create new group…</option>
        </select>
      </div>
    </>
  );
};
